import { render, staticRenderFns } from "./DrawingVideo.vue?vue&type=template&id=572d77fe&scoped=true"
import script from "./DrawingVideo.vue?vue&type=script&lang=js"
export * from "./DrawingVideo.vue?vue&type=script&lang=js"
import style0 from "./DrawingVideo.vue?vue&type=style&index=0&id=572d77fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d77fe",
  null
  
)

export default component.exports